import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { Paper, Icon } from '@mui/material';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';
import { formatFileSize } from './dataImportUtils';

// Step 2 of the import flow: drag-and-drop (or click-to-browse) upload of the
// filled-in .xlsx/.xls/.csv file.
const FileUploadZone = ({ fileName, fileSize, onDrop, onClearFile }) => (
  <>
    <MDTypography variant="h6" mb={2}>Step 2 &mdash; Upload File</MDTypography>
    <Dropzone
      onDrop={onDrop}
      accept={{
        'text/csv': ['.csv'],
        'application/vnd.ms-excel': ['.xls'],
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      }}
      maxFiles={1}
    >
      {({ getRootProps, getInputProps, isDragActive }) => (
        <Paper
          {...getRootProps()}
          variant="outlined"
          sx={{
            p: 3,
            textAlign: 'center',
            cursor: 'pointer',
            borderStyle: 'dashed',
            borderWidth: 2,
            borderColor: isDragActive ? 'info.main' : fileName ? 'success.main' : 'grey.300',
            bgcolor: isDragActive ? 'rgba(56,84,246,0.06)' : 'transparent',
            transition: 'border-color 150ms ease, background-color 150ms ease',
            '&:hover': { borderColor: 'info.main' },
          }}
        >
          <input {...getInputProps()} />
          <Icon sx={{ fontSize: 40, color: fileName ? 'success.main' : 'text.secondary' }}>
            {fileName ? 'task' : 'cloud_upload'}
          </Icon>
          <MDTypography variant="body2" fontWeight={fileName ? 'medium' : 'regular'} color="text" mt={1}>
            {fileName || (isDragActive ? 'Drop the file here…' : 'Drag & drop your file here, or click to browse')}
          </MDTypography>
          {fileSize ? (
            <MDTypography variant="caption" color="text">
              {formatFileSize(fileSize)}
            </MDTypography>
          ) : (
            <MDTypography variant="caption" color="text">
              Accepts .xlsx, .xls, or .csv
            </MDTypography>
          )}
        </Paper>
      )}
    </Dropzone>

    {fileName && (
      <MDButton
        variant="text"
        color="error"
        size="small"
        fullWidth
        sx={{ mt: 1 }}
        startIcon={<Icon>close</Icon>}
        onClick={onClearFile}
      >
        Remove &amp; choose a different file
      </MDButton>
    )}
  </>
);

FileUploadZone.propTypes = {
  fileName: PropTypes.string,
  fileSize: PropTypes.number,
  onDrop: PropTypes.func.isRequired,
  onClearFile: PropTypes.func.isRequired,
};

FileUploadZone.defaultProps = {
  fileName: null,
  fileSize: null,
};

export default FileUploadZone;
